module.exports = __webpack_public_path__ + "static/img/spa-book.3f51f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat-images/seat/spa-book.png
// module id = Gj05
// module chunks = 1